import script from "./color-phasing-element.vue?vue&type=script&setup=true&lang=ts"
export * from "./color-phasing-element.vue?vue&type=script&setup=true&lang=ts"

import "./color-phasing-element.vue?vue&type=style&index=0&id=ea0b71ac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea0b71ac"]])

export default __exports__